import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaFilePdf,
    FaCalendarAlt
} from 'react-icons/fa';

const EngineerExtendLimitEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    // Form state matching the image
    const [formData, setFormData] = useState({
        name: "आदित्य शंकर गावडे",
        phone: "7028201417",
        email: "gavdeaditya@gmail.com",
        aadhaar: "577040906735",
        qualification: "Diploma",
        address: "मु. पो. वडगाव कांदळी, ता. जुन्नर, जि. पुणे",
        startDate: "2021-12-09",
        endDate: "2026-08-12",
        status: "Approved",
        remarks: "Done"
    });

    return (
        <EngineerLayout>
            <div className="p-4 md:p-6 bg-[#f4f7fe] min-h-screen font-sans">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 px-2">
                    <div className="flex flex-col">
                        <h1 className="text-xl font-bold text-gray-800">Update Status</h1>
                        <p className="text-sm font-medium text-gray-500 font-marathi mt-1">अर्जदार- {formData.name}</p>
                    </div>
                    <div className="text-xs font-bold text-gray-400 mt-2 md:mt-0">
                        Zilla Parishad / <span className="text-gray-500 font-bold uppercase tracking-tight">Update Status</span>
                    </div>
                </div>

                {/* Main Form Container */}
                <div className="bg-white rounded shadow-sm border border-gray-100 p-6 md:p-8">
                    <div className="max-w-7xl mx-auto space-y-6">
                        
                        {/* Basic Info Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
                            {/* Left Column */}
                            <div className="space-y-6">
                                <div>
                                    <label className="block text-sm font-bold text-red-700 mb-2">Name Of Applicant <span className="text-red-500">*</span></label>
                                    <input 
                                        type="text" 
                                        className="w-full border border-gray-200 rounded px-3 py-2 text-sm bg-gray-50/50 text-gray-600 font-marathi outline-none"
                                        value={formData.name}
                                        readOnly
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-red-700 mb-2">Email Id<span className="text-red-500">*</span></label>
                                    <input 
                                        type="email" 
                                        className="w-full border border-gray-200 rounded px-3 py-2 text-sm bg-gray-100 text-gray-600 outline-none"
                                        value={formData.email}
                                        readOnly
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-red-700 mb-2">Qualification<span className="text-red-500">*</span></label>
                                    <input 
                                        type="text" 
                                        className="w-full border border-gray-200 rounded px-3 py-2 text-sm bg-gray-100 text-gray-600 outline-none"
                                        value={formData.qualification}
                                        readOnly
                                    />
                                </div>
                            </div>

                            {/* Right Column */}
                            <div className="space-y-6">
                                <div>
                                    <label className="block text-sm font-bold text-red-700 mb-2">Phone No. <span className="text-red-500">*</span></label>
                                    <input 
                                        type="text" 
                                        className="w-full border border-gray-200 rounded px-3 py-2 text-sm bg-gray-100 text-gray-600 outline-none"
                                        value={formData.phone}
                                        readOnly
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-red-700 mb-2">Addhar No. (आधार क्रमांक)<span className="text-red-500">*</span></label>
                                    <input 
                                        type="text" 
                                        className="w-full border border-gray-200 rounded px-3 py-2 text-sm bg-gray-100 text-gray-600 outline-none"
                                        value={formData.aadhaar}
                                        readOnly
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-red-700 mb-2">Present Address (सध्याचा पत्ता)<span className="text-red-500">*</span></label>
                                    <textarea 
                                        className="w-full border border-gray-200 rounded px-3 py-2 text-sm bg-white text-gray-600 font-marathi outline-none h-[42px] resize-none"
                                        value={formData.address}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Divider Line */}
                        <div className="border-b border-dotted border-blue-400/50 pt-2"></div>

                        {/* Photo and Signature Row */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                            <div>
                                <label className="block text-sm font-bold text-gray-400 mb-3 font-marathi tracking-tight">आय कार्ड साईझ फोटो (I card size photo)</label>
                                <div className="w-12 h-16 bg-gray-100 border border-gray-200 overflow-hidden">
                                    <img src="https://via.placeholder.com/50x64" alt="user" className="w-full h-full object-cover" />
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-400 mb-3 font-marathi tracking-tight">अर्जदाराची स्वाक्षरी ( Signature )</label>
                                <div className="w-24 h-8 bg-white border border-gray-50 flex items-center justify-center italic text-[10px] text-blue-300">
                                    Signature
                                </div>
                            </div>
                        </div>

                        {/* Documents Section */}
                        <div className="space-y-6 pt-2">
                            {/* Doc 1 */}
                            <div className="border-b border-dotted border-blue-400/50 pb-4">
                                <label className="block text-sm font-bold text-gray-700 mb-3 font-sans">Certificate (Nondani Pramanpatr)<span className="text-red-500">*</span></label>
                                <div className="w-10 h-12 bg-white border border-gray-100 shadow-sm flex items-center justify-center cursor-pointer hover:bg-gray-50 transition">
                                    <FaFilePdf size={24} className="text-red-500" />
                                </div>
                            </div>

                            {/* Doc 2 */}
                            <div className="border-b border-dotted border-blue-400/50 pb-4">
                                <label className="block text-sm font-bold text-gray-700 mb-3 font-sans">Employement Card <span className="text-red-500">*</span></label>
                                <div className="w-10 h-12 bg-white border border-gray-100 shadow-sm flex items-center justify-center cursor-pointer hover:bg-gray-50 transition">
                                    <FaFilePdf size={24} className="text-red-500" />
                                </div>
                            </div>

                            {/* Doc 3 */}
                            <div className="border-b border-dotted border-blue-400/50 pb-4">
                                <label className="block text-sm font-bold text-gray-700 mb-3 font-sans">चलन पावती (Challan Receipt )<span className="text-red-500">*</span></label>
                                <div className="w-10 h-12 bg-white border border-gray-100 shadow-sm flex items-center justify-center cursor-pointer hover:bg-gray-50 transition">
                                    <FaFilePdf size={24} className="text-red-500" />
                                </div>
                            </div>
                        </div>

                        {/* Validity Dates */}
                        <div className="space-y-8 pt-4">
                            <label className="block text-sm font-bold text-red-700 font-sans tracking-tight">Certificate Term - (Start and End Date)<span className="text-red-500">*</span></label>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 max-w-4xl">
                                <div>
                                    <label className="block text-xs font-bold text-gray-400 mb-2 font-marathi">Certificate Start Date (प्रमाणपत्र तारीख)</label>
                                    <div className="relative group">
                                        <input 
                                            type="text" 
                                            className="w-full border border-gray-300 rounded px-3 py-1.5 text-sm bg-white text-gray-600 outline-none"
                                            value="09 - 12 - 2021"
                                            readOnly
                                        />
                                        <FaCalendarAlt className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-xs font-bold text-gray-400 mb-2 font-marathi">Certificate End Date (प्रमाणपत्र तारीख)</label>
                                    <div className="relative group">
                                        <input 
                                            type="text" 
                                            className="w-full border border-gray-300 rounded px-3 py-1.5 text-sm bg-white text-gray-600 outline-none"
                                            value="08 - 12 - 2026"
                                            readOnly
                                        />
                                        <FaCalendarAlt className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Status Selection */}
                        <div className="border-t border-dotted border-blue-400/50 pt-8 space-y-8">
                            <div className="max-w-md">
                                <label className="block text-sm font-bold text-red-700 mb-2 font-sans">Status <span className="text-red-500">*</span></label>
                                <select 
                                    className="w-full border border-gray-300 rounded px-3 py-1.5 text-sm bg-white text-gray-600 outline-none appearance-none cursor-pointer"
                                    value={formData.status}
                                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                                >
                                    <option value="Approved">Approved</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Rejected">Rejected</option>
                                </select>
                            </div>

                            <div className="max-w-4xl">
                                <label className="block text-sm font-bold text-red-700 mb-2 font-sans">Remarks <span className="text-red-500">*</span></label>
                                <textarea 
                                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-white text-gray-700 outline-none h-24 font-marathi"
                                    value={formData.remarks}
                                    onChange={(e) => setFormData({...formData, remarks: e.target.value})}
                                />
                            </div>
                        </div>

                        {/* Footer Buttons Centered */}
                        <div className="border-t border-dotted border-blue-400/50 pt-8 pb-4 flex justify-center gap-2">
                            <button className="bg-[#4e73df] hover:bg-[#2e59d9] text-white px-4 py-2 rounded text-xs font-bold transition-all font-sans">
                                Update Status
                            </button>
                            <button 
                                onClick={() => navigate('/engineer/extend-limit')}
                                className="bg-[#5bc0de] hover:bg-[#31b0d5] text-white px-4 py-2 rounded text-xs font-bold transition-all font-sans"
                            >
                                close
                            </button>
                        </div>
                    </div>
                </div>

                {/* Footer Copy */}
                <div className="mt-8 text-center text-[10px] text-gray-500 font-sans tracking-tight">
                    Owned and Operated by ZPGOV. Copyright © 2026. All Rights Reserved.
                </div>
            </div>

            <style>{`
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerExtendLimitEdit;
